import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { SeoHead } from '../features/content/components/Seo';
import { SiteFooter } from './public/SiteFooter';
import { SiteHeader } from './public/SiteHeader';

export function PublicLayout() {
  const { pathname } = useLocation();
  // New page, new scroll position (filters that only change the query string keep it).
  // Block body: scrollTo returns a Promise in current Chrome, and an effect may only return a cleanup function.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="site-dark flex min-h-dvh flex-col">
      <SiteHeader />
      <SeoHead />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
